import React, { useContext } from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";

import imgBanner from "assets/images/pages/slichka/slichka-banner.jpg";
import imgIdeas2 from "assets/images/pages/slichka/slichka-ideas2.jpg";
import imgIdeas1 from "assets/images/pages/slichka/slichka-ideas1.jpg";
import imgResult2 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-result3.jpg";
import { PAGES } from "constants/pages";
import Section from "components/Section/Section";
import { ImageContainer } from "./CaseStudySlichka.styled";
import Image from "components/Image/Image";
import useDevice from "hooks/useDevice";
import Screen1 from "assets/images/pages/slichka/screen1.jpg";
import Screen2 from "assets/images/pages/slichka/screen2.jpg";
import Screen3 from "assets/images/pages/slichka/screen3.jpg";
import Screen4 from "assets/images/pages/slichka/screen4.jpg";
import Screen5 from "assets/images/pages/slichka/screen5.jpg";
import imgPerson1 from "assets/images/pages/home/clients/Zoran.jpg";
import { ColorModeContext } from "context/ColorModeContext";

const CaseStudySlichkaPage = () => {
  const { t } = useTranslation();
  const { theme } = useContext(ColorModeContext);
  const { isMobile } = useDevice();
  document.title = t(PAGES.CASE_STUDY_AI_ANOMALY_DETECTION.title);

  const images = [Screen1, Screen2, Screen3, Screen4, Screen5];

  const data = {
    banner: {
      header: "caseStudies.slichka.banner.header",
      text: "caseStudies.slichka.banner.text",
      badges: t("caseStudies.slichka.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
      imageHeight: 430,
      highlightColor: theme.colors.thertiary,
    },
    stats: t("caseStudies.slichka.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.slichka.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.slichka.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.slichka.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t("caseStudies.slichka.businessChallenges", {
      returnObjects: true,
    }),
    ourSolutions: t("caseStudies.slichka.ourSolutions", {
      returnObjects: true,
    }),
    theResults: {
      header: "caseStudies.slichka.theResults.header",
      content: [
        {
          header: t("caseStudies.slichka.theResults.results.result1.text"),
          imageText: t(
            "caseStudies.inspectMaster.theResults.results.result1.number"
          ),
          bgColor: "white",
        },
        {
          header: t("caseStudies.slichka.theResults.results.result2.text"),
          image: imgResult2,
          bgColor: "secondary",
        },
        {
          header: t("caseStudies.slichka.theResults.results.result3.text"),
          imageText: t("caseStudies.slichka.theResults.results.result3.number"),
          bgColor: "thertiary",
        },
      ],
    },
    sthForOur: {
      header: "caseStudies.slichka.sthForOur.header",
      client: {
        personName: t(
          "caseStudies.slichka.sthForOur.client.person.name"
        ),
        personPosition: t(
          "caseStudies.slichka.sthForOur.client.person.position"
        ),
        message: t("caseStudies.slichka.sthForOur.client.text"),
        personImg: imgPerson1,
      },
    },
    moreStories: {
      title: t("caseStudies.slichka.moreStories.header"),
      stories: t("caseStudies.slichka.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return (
    <CaseStudyTemplatePage data={data}>
      <Section>
        <ImageContainer>
          {images.map((item, index) => (
            <Image
              key={index}
              image={item}
              width={isMobile ? "72px" : "180px"}
              height={"auto"}
              objectFit="contain"
            />
          ))}
        </ImageContainer>
      </Section>
    </CaseStudyTemplatePage>
  );
};

export default CaseStudySlichkaPage;
